import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core'

@Component({
  selector: 'gb-infinite-scroll',
  templateUrl: './gb-infinite-scroll.component.html',
  styleUrls: ['./gb-infinite-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbInfiniteScrollComponent implements AfterViewInit, OnDestroy {
  @Input() options: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  }
  @Output() scrolled = new EventEmitter()
  @ViewChild('anchor', { static: false }) anchor!: ElementRef<HTMLElement>

  private observer?: IntersectionObserver

  ngAfterViewInit(): void {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.scrolled.emit()
        }
      }, this.options)

      this.observer.observe(this.anchor.nativeElement)
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
